import { makeT9nController as o } from "@arcgis/components-controllers";
import { g as t } from "./runtime.js";
/*! All material copyright Esri, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
v4.32.14 */
const s = o(t);
export {
  s as u
};
